/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {OptimizationSettings} from '../bioplanModels';
/**
 * OptimizationSettingsApi - axios parameter creator
 * @export
 */
export const OptimizationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete optimization settings for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdDelete: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('optimizationSettingsPlanIdDelete', 'planId', planId);
      const localVarPath = `/optimizationSettings/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get optimization parameters for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('optimizationSettingsPlanIdGet', 'planId', planId);
      const localVarPath = `/optimizationSettings/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update optimization settings for a plan
     * @param {string} planId
     * @param {OptimizationSettings} optimizationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdPut: async (
      planId: string,
      optimizationSettings: OptimizationSettings,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('optimizationSettingsPlanIdPut', 'planId', planId);
      // verify required parameter 'optimizationSettings' is not null or undefined
      assertParamExists('optimizationSettingsPlanIdPut', 'optimizationSettings', optimizationSettings);
      const localVarPath = `/optimizationSettings/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(optimizationSettings, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OptimizationSettingsApi - functional programming interface
 * @export
 */
export const OptimizationSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OptimizationSettingsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete optimization settings for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationSettingsPlanIdDelete(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationSettingsPlanIdDelete(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationSettingsApi.optimizationSettingsPlanIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get optimization parameters for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationSettingsPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptimizationSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationSettingsPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationSettingsApi.optimizationSettingsPlanIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update optimization settings for a plan
     * @param {string} planId
     * @param {OptimizationSettings} optimizationSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async optimizationSettingsPlanIdPut(
      planId: string,
      optimizationSettings: OptimizationSettings,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptimizationSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationSettingsPlanIdPut(
        planId,
        optimizationSettings,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OptimizationSettingsApi.optimizationSettingsPlanIdPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OptimizationSettingsApi - factory interface
 * @export
 */
export const OptimizationSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OptimizationSettingsApiFp(configuration);
  return {
    /**
     *
     * @summary Delete optimization settings for a plan
     * @param {OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdDelete(
      requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .optimizationSettingsPlanIdDelete(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get optimization parameters for a plan
     * @param {OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdGet(
      requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OptimizationSettings> {
      return localVarFp
        .optimizationSettingsPlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update optimization settings for a plan
     * @param {OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    optimizationSettingsPlanIdPut(
      requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OptimizationSettings> {
      return localVarFp
        .optimizationSettingsPlanIdPut(requestParameters.planId, requestParameters.optimizationSettings, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for optimizationSettingsPlanIdDelete operation in OptimizationSettingsApi.
 * @export
 * @interface OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest
 */
export interface OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationSettingsApiOptimizationSettingsPlanIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for optimizationSettingsPlanIdGet operation in OptimizationSettingsApi.
 * @export
 * @interface OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest
 */
export interface OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationSettingsApiOptimizationSettingsPlanIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for optimizationSettingsPlanIdPut operation in OptimizationSettingsApi.
 * @export
 * @interface OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest
 */
export interface OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizationSettingsApiOptimizationSettingsPlanIdPut
   */
  readonly planId: string;

  /**
   *
   * @type {OptimizationSettings}
   * @memberof OptimizationSettingsApiOptimizationSettingsPlanIdPut
   */
  readonly optimizationSettings: OptimizationSettings;
}

/**
 * OptimizationSettingsApi - object-oriented interface
 * @export
 * @class OptimizationSettingsApi
 * @extends {BaseAPI}
 */
export class OptimizationSettingsApi extends BaseAPI {
  /**
   *
   * @summary Delete optimization settings for a plan
   * @param {OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationSettingsApi
   */
  public optimizationSettingsPlanIdDelete(
    requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationSettingsApiFp(this.configuration)
      .optimizationSettingsPlanIdDelete(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get optimization parameters for a plan
   * @param {OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationSettingsApi
   */
  public optimizationSettingsPlanIdGet(
    requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationSettingsApiFp(this.configuration)
      .optimizationSettingsPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update optimization settings for a plan
   * @param {OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OptimizationSettingsApi
   */
  public optimizationSettingsPlanIdPut(
    requestParameters: OptimizationSettingsApiOptimizationSettingsPlanIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OptimizationSettingsApiFp(this.configuration)
      .optimizationSettingsPlanIdPut(requestParameters.planId, requestParameters.optimizationSettings, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
